<template>
  <div class="b1">
    <div class="flex_between_nowrap">
      <span class="title_before side_title">区域管理</span>
    </div>
    <div style="padding:0px 20px 0px 24px">
      <div
        class="flex_between_nowrap"
        style="margin-top:20px;margin-bottom:30px"
      >
        <el-input
        clearable
          placeholder="请输入名称或编号"
          size="small"
          v-model="params['search']"
          style="width:300px;"
        >
          <i
            slot="suffix"
            class="el-icon-search inputIcon "
            @click.stop="tableSearch"
          ></i>
        </el-input>
        <el-button type="submit" @click="add_area({})">新增</el-button>
      </div>
      <x-table
        url="/pc/area/page"
        ref="xTable"
        :params="params"
        :columnArr="columnArr"
      >
          <el-table-column label="操作" align='center'>
          <template slot-scope="scope">
            <el-button type="text" class="addColor" @click="add_area(scope.row)"
              >编辑</el-button
            >
            <el-button
              type="text"
              class="deleteColor"
              @click="
                $axiosDelete('/pc/area/del', { id: scope.row.id }, tableSearch,'',true)
              "
              >删除</el-button
            >
          </template>
        </el-table-column>
      </x-table>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      params: {},
      columnArr: [
        {
          label: "区域名称",
          model: "aName",
        },
        {
          label: "区域编号",
          model: "aCode",
        },
        {
          label: "操作人",
          model: "createName",
        },

        {
          label: "操作时间",
          model: "createTime",
        },
      ],
    };
  },
  mounted() {},
  methods: {
    tableSearch() {
      this.$refs.xTable.search();
    },
    add_area(row) {
      this.$createDialog(this, {
        dialogConfig: {
          title: JSON.stringify(row) == "{}" ? "区域新增" : "区域编辑",
          width: "360px",
        },
        namespace: "sys_add_area",
        whetherDestruction: true,

        assemblyConfig: {
          row: row,
          callBack: this.tableSearch,
        },
      });
    },
  },
};
</script>
<style scoped></style>
